import React, { useContext } from 'react';
import { useTranslations } from 'next-intl';

import Copy from '@components/atoms/copy/copy';
import { Context } from '../../../context/provider';

const FilterClearButton = () => {
  const t = useTranslations();
  const { resetFilter } = useContext(Context);

  return (
    <button className="clear" onClick={resetFilter} type="button">
      <Copy small>{t('archive.clearLabel')}</Copy>
    </button>
  );
};

export default FilterClearButton;
